export default "__VITE_ASSET__CYpb5lOY__"